import PlaylistTemplateService from "../../services/PlaylistTemplateService";

const initialState = {
  list: [],
  current: {}
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    ADD_TEMPLATE(state, template) {
      state.list.push(template);
    },
    SET_TEMPLATES(state, templates) {
      state.list = templates;
    },
    SET_TEMPLATE(state, template) {
      state.current = template;
    }
  },
  actions: {
    createTemplate({ commit }, template) {
      return PlaylistTemplateService.postTemplate(template).then(() => {
        commit("ADD_TEMPLATE", template);
      });
    },
    fetchTemplates({ commit }) {
      return PlaylistTemplateService.getTemplates().then(response => {
        commit("SET_TEMPLATES", response.data.data);
      });
    },
    fetchTemplate({ commit, getters }, id) {
      var template = getters.getElementById(id);
      if (template) {
        commit("SET_TEMPLATE", template);
        return template;
      } else {
        return PlaylistTemplateService.getTemplate(id).then(response => {
          commit("SET_TEMPLATE", response.data);
          return response.data;
        });
      }
    },
    clearCurrent({ commit }) {
      commit("SET_TEMPLATE", {});
    }
  },
  getters: {
    getElementById: state => id => {
      return state.list.find(element => element.id === id);
    },
    filterList: state => pattern => {
      return state.list.filter(elem =>
        elem.name.toLowerCase().includes(pattern.toLowerCase())
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/playlistTemplates.js